module.exports = __webpack_public_path__ + "img/icon_d.10b60f83.png";